import React from 'react';
import { DegreeLengthCard } from '@/components/DesignSystem/Cards';
import { useCalculatorContext } from '@/components/DesignSystem/Subsections/Calculator/contexts';
import DegreeLengthProgress from '@/components/DesignSystem/Subsections/DegreeLength/subcomponents/DegreeLengthProgress';

interface DegreeLengthProps {
  className?: string;
}

const DegreeLength: React.FC<DegreeLengthProps> = ({ className = '' }) => {
  const { state, variant, updateCalculatorValue, results, occupations } =
    useCalculatorContext();

  const urgency = state?.calculatorValues?.urgency;
  const work = state?.calculatorValues?.workCommitment;

  const isPartTime =
    urgency === 'low' || (work === 'full-time' && urgency === 'medium');
  const isFullTime =
    (work === 'part-time' && urgency === 'medium') ||
    (work === 'full-time' && urgency === 'high');
  const isAccelerated = work === 'part-time' && urgency === 'high';

  return (
    <div className={`degree-length-container ${className}`}>
      {variant === 'degree-length' && (
        <div>
          <DegreeLengthProgress className='mb-4' />
        </div>
      )}
      <div className='grid grid-cols-1 gap-6'>
        {/* Part-Time Evening */}
        <DegreeLengthCard
          title='Part-Time'
          studyTime='20-30 hrs/week'
          classesPerSemester={2}
          semestersPerYear={2}
          isRecommended={isPartTime}
        />
        {/* Full-Time Traditional */}
        <DegreeLengthCard
          title='Full-Time Traditional'
          studyTime='Standard fulltime, fall + spring'
          classesPerSemester={4}
          semestersPerYear={2}
          isRecommended={isFullTime}
        />

        {/* Accelerated Year-Round */}
        <DegreeLengthCard
          title='Accelerated Year-Round'
          studyTime='~40 hrs/week commitment'
          classesPerSemester={5}
          semestersPerYear={3}
          isRecommended={isAccelerated}
        />
      </div>
    </div>
  );
};

export default DegreeLength;
